const AdminPageTypes = {
    CREDENCIAMENTO: 'CREDENCIAMENTO',
    NUCLEOS: 'NUCLEOS',
    PAISES: 'PAISES',
    LOADING: 'LOADING',
    BLANK: 'BLANK',
    CIDADES: 'CIDADES',
    EVENTS: 'EVENTS',
    CURSOS: 'CURSOS',
    PERFIS: 'PERFIS',
    USUARIOS: 'USUARIOS',
    APOSTILAS: 'APOSTILAS',
    PRODUTOS: 'PRODUTOS',
    IMPRESSORAS: 'IMPRESSORAS',
    PRESENCA: 'PRESENCA',
    PARTICIPANTES: 'PARTICIPANTES',
    PARTICIPANTES_LIMITED: 'PARTICIPANTES_LIMITED',
    IMPORTACAO: 'IMPORTACAO',
    IMPORTACAO_PRODUTOS: 'IMPORTACAO_PRODUTOS',
    LOGOUT: 'LOGOUT',
    VENDA: 'VENDA',
    RELATORIO_DASHBOARD: 'RELATORIO_DASHBOARD',
    RELATORIO_VENDAS_TOTAIS: 'RELATORIO_VENDAS_TOTAIS',
    RELATORIO_VENDAS_DOS_NUCLEOS: 'RELATORIO_VENDAS_DOS_NUCLEOS',
    RELATORIO_VENDAS_PARA_NUCLEOS: 'RELATORIO_VENDAS_PARA_NUCLEOS',
    RELATORIO_VENDAS_POR_PRODUTOS: 'RELATORIO_VENDAS_POR_PRODUTOS',
    RELATORIO_CARRINHOS_PAGOS: 'RELATORIO_CARRINHOS_PAGOS',
    RELATORIO_VENDAS_POR_PAGAMENTO: 'RELATORIO_VENDAS_POR_PAGAMENTO',
    RELATORIO_COMPRADORES_POR_PRODUTO: 'RELATORIO_COMPRADORES_POR_PRODUTO',
    RELATORIO_APOSTILAS_POR_NUCLEO: 'RELATORIO_APOSTILAS_POR_NUCLEO',
    DISTRIBUICAO_VENDAS: 'DISTRIBUICAO_VENDAS',
    ACUMULADO_VENDAS: 'ACUMULADO_VENDAS',
    CAIXA: 'CAIXA',
    EXPEDICAO: 'EXPEDICAO',
    VENDA_CAIXA: 'VENDA_CAIXA',
    CAIXA_EXPEDICAO: 'CAIXA_EXPEDICAO',
    VENDA_CAIXA_EXPEDICAO: 'VENDA_CAIXA_EXPEDICAO',
    PEDIDOS_PAGOS: 'PEDIDOS_PAGOS',
    EMAILS: 'EMAILS',
    SORTEIO: 'SORTEIO',
};

export default AdminPageTypes;



// WEBPACK FOOTER //
// src/views/AdminPageTypes.js